module.exports = __webpack_public_path__ + "img/qilin-stage6.0162db2d.png";